import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {

  constructor(
    private http: HttpService,
  ) { }

  userExists(formControl: any) {
    const body = {
      type: formControl.type,
    }

    body[formControl.formControlName] = formControl.value;

    if (formControl.extra) {
      body[formControl.extra.field] = formControl.extra.value;
    }
    return this.http.request('POST', 'applicant', body, {extraUri: `exists`})
      .pipe(map(data => {
        return data;
      }));
  }

}
